import React from "react";

/**
 * Curved SVG section divider — gives the soft, child-friendly transitions
 * between sections (Stonehill / Naavi reference style).
 *
 * @param {string} fill        - colour of the curve fill (= bg of section BELOW)
 * @param {string} bg          - colour of the section ABOVE (drawn in the rect)
 * @param {string} variant     - "wave" | "tilt" | "smile"
 * @param {string} className   - extra wrapper classes
 */
export default function SectionCurve({
  fill = "#FDFDF9",
  bg = "transparent",
  variant = "wave",
  flip = false,
  className = "",
}) {
  const paths = {
    wave:
      "M0 60 Q 360 0 720 60 T 1440 60 V90 H0 Z",
    tilt:
      "M0 0 V80 Q 240 20 480 60 T 960 50 T 1440 70 V0 Z",
    smile:
      "M0 90 V40 Q 720 -40 1440 40 V90 Z",
  };

  return (
    <div
      className={`w-full leading-[0] ${flip ? "rotate-180" : ""} ${className}`}
      style={{ background: bg }}
      aria-hidden="true"
    >
      <svg
        viewBox="0 0 1440 90"
        preserveAspectRatio="none"
        className="block w-full h-[50px] md:h-[80px]"
      >
        <path d={paths[variant] || paths.wave} fill={fill} />
      </svg>
    </div>
  );
}
